import { render, staticRenderFns } from "./Voting.vue?vue&type=template&id=5f46cd58"
import script from "./Voting.vue?vue&type=script&lang=js"
export * from "./Voting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports